<template>
  <Modal :is-open="isOpen" size="md" @close="toggleModalOpen">
    <HelperViewStatus
      title="Ao sair, a atualização cadastral não será salva"
      description="Evite o bloqueio de novos investimentos atualizando sua conta."
      status="alert"
    />
    <template #buttonContainer>
      <ButtonContainer>
        <ButtonPrimary
          slot="button-primary"
          label="Cancelar"
          @click="toggleModalOpen"
        />
        <ButtonSecondary
          slot="button-secondary"
          data-testid="close-confirmation-button"
          label="Sair"
          @click="exit"
        />
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  Modal,
  HelperViewStatus,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Modal,
    HelperViewStatus,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class RegulatoryUpdateCloseModal extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly isOpen!: boolean;

  @Emit()
  public toggleModalOpen() {}

  @Emit()
  public exit() {}
}
</script>

<style lang="less" scoped></style>
